import React, { useState, useEffect } from "react";
import { FaTrash, FaEdit, FaUserPlus } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import "../Styles/CardTorneo.css";
import { BASE_URL } from "../../../config";
import defaulUser from "../../../assets/defaultUser.png";
import { ToastContainer, toast } from "react-toastify";  
import 'react-toastify/dist/ReactToastify.css'; 

const CardParticipantes = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [personas, setPersonas] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [updatedName, setUpdatedName] = useState("");
  const [updatedPhoto, setUpdatedPhoto] = useState(null);
  const [previewPhoto, setPreviewPhoto] = useState("");
  const itemsPerPage = 6;

  useEffect(() => {
    const fetchPersonas = async () => {
      try {
        const response = await fetch(`${BASE_URL}personas`);
        const data = await response.json();
        setPersonas(data);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

    fetchPersonas();
  }, []);

  const filteredParticipantes = personas.filter(
    (persona) =>
      persona.nombres?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      persona.identificacion?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const handleEditClick = (persona) => {
    setSelectedPersona(persona);
    setUpdatedName(persona.nombres);
    setPreviewPhoto(persona.fotografiaPath || defaulUser); 
    setModalOpen(true);
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setUpdatedPhoto(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = () => setPreviewPhoto(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleUpdate = async () => {
    if (!selectedPersona) return;

    const formData = new FormData();
    formData.append("nombres", updatedName);
    if (updatedPhoto) formData.append("file", updatedPhoto);

    try {
      const response = await fetch(`${BASE_URL}persona/${selectedPersona.id}`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const updatedPersona = await response.json();
        setPersonas((prev) =>
          prev.map((p) => (p.id === updatedPersona.id ? updatedPersona : p))
        );
        setModalOpen(false);
        toast.success("¡Participante actualizado con éxito!");  
      } else {
        console.error("Error al actualizar la persona");
        toast.error("Hubo un error al actualizar el participante."); 
      }
    } catch (error) {
      console.error("Error en la actualización:", error);
      toast.error("Hubo un error al actualizar el participante."); 
    }
  };

  const displayParticipantes = filteredParticipantes
  .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
 
    .map((persona) => (
      <div key={persona.id} className="col-md-4 mb-4">
        <div className="card shadow-sm h-100">
          <div className="card-header text-center bg-primary text-white">
            <img
              src={persona.fotografiaPath || defaulUser}
              alt="Foto de perfil"
              className="rounded-circle mb-2"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
            />
            <h5>{persona.nombres}</h5>
          </div>
          <div className="card-body">
            <p className="card-text">
              <strong>Identificación:</strong> {persona.identificacion}
            </p>
          </div>
          <div className="card-footer d-flex justify-content-around">
            <button
              className="btn btn-warning btn-sm"
              onClick={() => handleEditClick(persona)}
            >
              <FaEdit /> Actualizar
            </button>
            {/* <button className="btn btn-danger btn-sm">
              <FaTrash /> Eliminar
            </button> */}
            {/* <button className="btn btn-success btn-sm">
              <FaUserPlus /> Agregar
            </button> */}
          </div>
        </div>
      </div>
    ));

  return (
    <div className="custom-container py-4">
      <h2 className="text-center mb-4">Gestión de Participantes</h2>

      <div className="mb-4">
        <input
          type="text"
          placeholder="Buscar participantes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control"
        />
      </div>

      <div className="row">{displayParticipantes}</div>

      {/* Paginación */}
      <div className="d-flex justify-content-center mt-4">
        <ReactPaginate
          pageCount={Math.ceil(filteredParticipantes.length / itemsPerPage)}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          activeClassName="active"
          previousLabel={"< Anterior"}
          nextLabel={"Siguiente >"}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          nextClassName="page-item"
          previousLinkClassName="page-link"
          nextLinkClassName="page-link"
        />
      </div>

      {modalOpen && (
        <div className="modal" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Editar Participante</h5>
                <button className="close" onClick={() => setModalOpen(false)}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Nombre</label>
                  <input
                    type="text"
                    className="form-control"
                    value={updatedName}
                    onChange={(e) => setUpdatedName(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label>Foto Actual</label>
                  <div className="text-center mb-3">
                    <img
                      src={previewPhoto}
                      alt="Vista previa"
                      className="rounded-circle"
                      style={{ width: "100px", height: "100px", objectFit: "cover" }}
                    />
                  </div>
                  <label>Cambiar Foto</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={handlePhotoChange}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setModalOpen(false)}>
                  Cancelar
                </button>
                <button className="btn btn-primary" onClick={handleUpdate}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export { CardParticipantes };
